import { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { Container, Row, Col, Carousel } from 'react-bootstrap';
import { FaGithub } from 'react-icons/fa';
import { BsGlobe2 } from "react-icons/bs";
import { FaGears } from "react-icons/fa6";
import { IoDiamondSharp } from "react-icons/io5";
import { IoDocumentText } from "react-icons/io5";
import { IoMdPhotos } from "react-icons/io";
import { TbZoomIn } from "react-icons/tb";
import { IoShieldCheckmark } from "react-icons/io5";
import { MdCheckCircleOutline } from "react-icons/md";

import { allProjects } from '../data/proyectos';
import './ProjectDetails.css';

function loadProjectImages(slug) {
  try {
    const context = require.context(
      '../assets/img/projects',
      true
    );
    return context
      .keys()
      .filter(key => key.includes(`/${slug}/`))
      .map(key => context(key));
  } catch {
    return [];
  }
}

export const ProjectDetails = () => {
  const { title } = useParams();
  const project = allProjects.find(p => p.title === decodeURIComponent(title));

  const [images, setImages] = useState([]);
  const [zoomIndex, setZoomIndex] = useState(null);

  const openZoom = (index) => {
    document.body.classList.add('pd-zoom-open');
    setZoomIndex(index)
  };
  const closeZoom = () => {
    setZoomIndex(null);
    document.body.classList.remove('pd-zoom-open');
  };

  useEffect(() => {
    if (!project?.slug) return;

    setImages(loadProjectImages(project.slug));

  }, [project?.slug]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="pd-wrapper">
      <Row className="gx-4">
        <Col xs={12} lg={12}>
          <div className="pd-hero">
            <img
              src={project.img}
              alt={project.title}
              className={'pd-hero__bg'}
            />
            <div className="pd-hero__overlay" />
            <div className="pd-hero__content">
              <span className={`pd-hero__tag pd-hero__tag--${project.disponibilidad === 'disponible' ? 'disponible' : 'desarrollo'}`}>
                {project.disponibilidad === 'disponible' ? '● Disponible' : '● En Revisión'}
              </span>
              <h1 className="pd-hero__title">{project.title}</h1>
              <p className="pd-hero__subtitle">{project.description}</p>
              <div className="pd-hero__buttons">
                {project.demoUrl && (
                  <a href={project.demoUrl} target="_blank" rel="noreferrer" className="pd-btn pd-btn--primary">
                    < BsGlobe2 size={'1.5em'} /> Ver Demo
                  </a>
                )}
                {project.githubUrl && (
                  <a href={project.githubUrl} target="_blank" rel="noreferrer" className="pd-btn pd-btn--secondary">
                    <FaGithub size={'1.5em'} /> GitHub Repo
                  </a>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Container className="pd-body">

        <Row className="gx-4 mb-4">
          <Col xs={12} lg={8}>
            <div className="pd-section">
              <h2 className="pd-section__title"> <IoMdPhotos size={'1em'} style={{ color: '#00d4ff' }} /> Galería</h2> {/*TODO ENCONTRAR TAMAÑO PERFECTO PARA IMÁGENES Y REDIMENSIONAR LAS DEL PROYECTO*/}
              {images.length > 0 && (
                <Carousel
                  interval={null}
                  className="pd-gallery"
                >
                  {images.map((img, i) => (
                    <Carousel.Item key={i}>
                      <div className="pd-gallery__item">
                        <img src={images[i]} className="pd-galery__bg" />
                        <button
                          className="pd-gallery__zoom"
                          onClick={() => openZoom(i)}
                        >
                          <TbZoomIn size={'1.5rem'} style={{ color: '#00d4ff' }} />
                        </button>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              )}
              {zoomIndex !== null && (
                <div className="pd-zoom-overlay">
                  <Carousel
                    activeIndex={zoomIndex}
                    onSelect={(i) => setZoomIndex(i)}
                    interval={null}
                    className="pd-zoom-carousel"
                    wrap={true}
                  >
                    {images.map((img, i) => (
                      <Carousel.Item key={i}>
                        <img src={img} alt={`Zoom ${i + 1}`} className="pd-zoom-img" />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                  <button className="pd-zoom-close" onClick={closeZoom}>✕</button>
                </div>
              )}
            </div>
            <div className="pd-section">
              <h2 className="pd-section__title"> <IoDocumentText size={'1.5em'} style={{ color: '#00d4ff' }} />  Sobre el proyecto</h2>
              <p className="pd-section__text">
                {project.descriptionLong.split('\n').map((line, i) => (
                  <span key={i}>
                    {line}
                    {i < project.descriptionLong.split('\n').length - 1 && <br />}
                  </span>
                ))}
              </p>
            </div>
          </Col>

          <Col xs={12} lg={4}>
            <div className="pd-section">
              <h2 className="pd-section__title"> <FaGears size={'1.5em'} style={{ color: '#00d4ff' }} /> Stack Tecnológico</h2>
              <div className="pd-tech-list">
                {project.technologiesLong.map(({ icon: Icon, name, color }, i) => (
                  <div key={i} className="pd-tech-item">
                    {Icon && <Icon size={22} color={color || "default"} />}
                    <span>{name}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="pd-section">
              <h2 className="pd-section__title"> <IoDiamondSharp size={'1.5em'} style={{ color: '#00d4ff' }} /> Funcionalidades</h2>
              <div className="pd-function-list">
                {project.features.map(({ icon: Icon, color, description }, i) => (
                  <div key={i} className="pd-function-item">
                    {Icon && <span style={{ color }}><Icon size={22} /></span>} {/*EJEMPLO DE COLOR EN ICONO, NECESARIO DEFINIRLO EN EL ARRAY DE PROYECTOS.JS*/}
                    <span>{description}</span>
                  </div>
                ))}
              </div>
            </div>
            {project.security && (
              <div className="pd-section">
                <h2 className="pd-section__title"> <IoShieldCheckmark size={'1.5em'} style={{ color: '#00d4ff' }} /> Seguridad Implementada</h2>
                <div className="pd-function-list">
                  {project.security.map((item, idx) => (
                    <div key={idx} className="pd-function-item" style={{ color: item.color }}>
                      <span><MdCheckCircleOutline size={'1.5rem'} color={'green'} /></span>
                      <span>{item.name}</span>
                    </div>
                  ))}
                </div>
              </div>)}
          </Col>
        </Row>
      </Container>
    </div>
  );
};